var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("group-page-header", { attrs: { title: "About Group" } }, [
        _c(
          "span",
          { attrs: { slot: "additionalButtons" }, slot: "additionalButtons" },
          [
            _vm.viewer_state.is_admin
              ? _c("toggle-edit-mode-button", {
                  model: {
                    value: _vm.editMode,
                    callback: function ($$v) {
                      _vm.editMode = $$v
                    },
                    expression: "editMode",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.group.is_private && _vm.viewer_state.is_admin
        ? _c(
            "div",
            { staticClass: "alert alert-info margin-15-bottom margin-15-top" },
            [
              _vm._v(
                "\n        This page is accessible to public. Only put information on the Group ‘About page’ that you are happy to\n        share\n        with everyone.\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "story-list",
        {
          attrs: {
            "story-resource": _vm.GroupStoryResource,
            "target-id": _vm.targetId,
            "edit-mode": _vm.editMode,
            "allow-add-content": _vm.viewer_state.is_admin,
            "add-button-text": "Add to About Page",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "alert alert-info",
              attrs: { slot: "empty" },
              slot: "empty",
            },
            [_vm._v("There has been nothing added to this Group's story yet")]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }